export const woocommerce = {
  keyHelp:
    'Der Key ist zu finden unter "WooCommerce > Settings > Advanced > REST API"',
  secretHelp:
    'Der Secret ist zu finden unter "WooCommerce > Settings > Advanced > REST API"'
};
